import { isEmpty } from 'lodash-es';
import React from 'react';
import Cldr from 'utils/Cldr';
import {
  cartDataProps,
  isTrialProps,
  trialInfoProps
} from '../../../shared/prop-types';
import styles from './styles.scss';

const Overview = ({ cartData, trialInfo, isTrial }) => {
  const { recurringAmount, currency } = cartData;

  const formattedAmount = Cldr.formatCurrency(recurringAmount, currency);

  const subtitle =
    isTrial && !isEmpty(trialInfo)
      ? `Free ${trialInfo.trialLength} day trial, then ${formattedAmount}/year`
      : `${formattedAmount}/year`; // TODO: [fumba] copy

  return (
    <div className={styles.container}>
      <h5 className="text-bold">Annual Student Plan</h5>
      {/* TODO: [fumba copy] */}
      <h6>{subtitle}</h6>
    </div>
  );
};

Overview.propTypes = {
  cartData: cartDataProps.isRequired,
  trialInfo: trialInfoProps,
  isTrial: isTrialProps.isRequired
};

Overview.defaultProps = {
  trialInfo: null
};
export default Overview;
